export const defaultAssetsUrl = "https://unpkg.com/@workadventure/scripting-api-extra@1.3.0/dist";
//# sourceMappingURL=default_assets_url.js.map